import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils.ts';

// תג: סוג יצירה, "נכון ל-", גרסה, שיתוף (מידע, לא מצב). מצב = StatusLabel (צבע מלא). הטון לעולם לא לבד, תמיד עם טקסט.
export type Tone = 'neutral' | 'info' | 'ok' | 'warn' | 'error';
const TONES: Record<Tone, string> = {
  neutral: 'bg-muted text-muted-foreground ring-border',
  info: 'bg-primary-soft text-primary ring-primary/25',
  ok: 'bg-ok/10 text-ok ring-ok/30',
  warn: 'bg-degraded/10 text-degraded ring-degraded/30',
  error: 'bg-error/10 text-error ring-error/30',
};

export function Badge({ tone = 'neutral', className, children, ...p }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn('inline-flex min-h-6 items-center gap-1.5 rounded-sm px-2 text-[13px] font-medium whitespace-nowrap ring-1 ring-inset', TONES[tone], className)}
      {...p}
    >
      {children}
    </span>
  );
}

// תווית מצב (web-visual-identity, בסגנון monday): מלבן בפינות 4px בצבע מלא, טקסט מנוגד (≥ 4.5:1 בשתי הערכות);
// תמיד עם מילה. ok ירוק · warn כתום (ממתין/בעבודה) · error אדום · neutral אפור · info כחול (רץ).
const FILLS: Record<Tone, string> = {
  neutral: 'bg-status-neutral text-on-status-neutral',
  info: 'bg-action text-action-foreground',
  ok: 'bg-status-ok text-on-status-ok',
  warn: 'bg-status-wait text-on-status-wait',
  error: 'bg-status-err text-on-status-err',
};

export function StatusLabel({ tone = 'neutral', className, children, ...p }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      data-status-label={tone}
      className={cn('inline-flex min-h-6 items-center justify-center gap-1 rounded-sm px-2.5 text-[13px] font-medium whitespace-nowrap', FILLS[tone], className)}
      {...p}
    >
      {children}
    </span>
  );
}

/** טון לסטטוס ריצה (09): done ירוק, failed/timeout אדום, waiting_consent צהוב, בתהליך כחול. */
export function runTone(status: string): Tone {
  if (status === 'done') return 'ok';
  if (status === 'failed' || status === 'timeout') return 'error';
  if (status === 'canceled') return 'neutral';
  if (status === 'waiting_consent') return 'warn';
  return 'info';
}
